<strong *ngIf="linkHref">
  <a [href]="linkHref">
    {{linkData.content}}
    <span *ngIf="linkData?.ext">{{'CORE.CONTACT.ext' | translate}} {{linkData.ext}}</span>
  </a>
</strong>

<strong *ngIf="!linkHref">
  {{linkData.content}}
</strong>